//app/features/questionnaires/checkout/components/SignEngagementLetter.tsx
import React, { useState } from 'react';

interface ISignEngagementLetter {
  sign_url: string;
}

const SignEngagementLetter = ({ sign_url }: ISignEngagementLetter) => {
  const [fallbackVisible, setFallbackVisible] = useState(false);

  const openEngagementAndSurvey = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();

    // Try to open the engagement letter in a new tab
    const engagementTab = window.open(
      sign_url,
      '_blank',
      'noopener,noreferrer',
    );
    if (!engagementTab) {
      setFallbackVisible(true);
      return;
    }

    // After a short delay, try to open the survey
    setTimeout(() => {
      const surveyTab = window.open(
        'https://us16.list-manage.com/survey?u=74a0e04a8fc87374ff7e06f81&id=4d1daeedb0&attribution=false',
        '_blank',
        'noopener,noreferrer',
      );
      if (!surveyTab) {
        setFallbackVisible(true);
      }
    }, 100);
  };

  return (
    <div className="bg-green-20 rounded-2xl py-3 px-4">
      <h2 className="font-bold text-regular text-gray-dark">
        Sign Engagement Letter
      </h2>
      <p className="text-base text-gray-dark mt-2 mb-3">
        Please go to this{' '}
        <a
          href="#"
          onClick={openEngagementAndSurvey}
          className="text-base font-medium text-gray-dark underline"
          rel="noreferrer"
        >
          link
        </a>{' '}
        and sign the engagement letter to proceed with payment.
      </p>
      {fallbackVisible && (
        <div className="mt-4 p-4 bg-red-100 text-red-700 rounded">
          <p>
            It looks like your browser is blocking pop-ups. Please click the
            links below manually:
          </p>
          <ul className="list-disc ml-5">
            <li>
              <a
                href={sign_url}
                target="_blank"
                rel="noreferrer"
                className="underline text-blue-600"
              >
                Engagement Letter
              </a>
            </li>
            <li>
              <a
                href="https://us16.list-manage.com/survey?u=74a0e04a8fc87374ff7e06f81&id=4d1daeedb0&attribution=false"
                target="_blank"
                rel="noreferrer"
                className="underline text-blue-600"
              >
                Survey
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default SignEngagementLetter;
